



































import Vue from 'vue';
import pipeline from '@/pipeline';
import IdentificationDocumentFinancialSponsorForm, {
  IdentificationDocumentFinancialSponsorFormEvent,
} from '@/components/forms/studentData/IdentificationDocumentFinancialSponsorForm.vue';
import PipelineMenu from '@/components/PipelineMenuWrapper.vue';
import BottomButton from '@/components/BottomButton.vue';
import BackButton from '@/components/BackButton.vue';
import { IdentificationDocumentFinancialSponsor } from '@/store/modules/studentData/state';
import { AutocompleteOption, parseToAutocompleteOptionArray } from '@/helpers/autocomplete';

export default Vue.extend({
  components: {
    BackButton,
    BottomButton,
    IdentificationDocumentFinancialSponsorForm,
    PipelineMenu,
  },
  data() {
    return {
      form: {
        rg: this.$store.getters.identificationDocumentFinancialSponsor?.rg || '',
        issueDate: this.$store.getters.identificationDocumentFinancialSponsor?.issueDate || '',
        issuer: this.$store.getters.identificationDocumentFinancialSponsor?.issuer || '',
        issueState: this.$store.getters.identificationDocumentFinancialSponsor?.issueState || '',
      },
      hasErrors: false,
      isContinueDisabled: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      return Object.values(this.form).every(Boolean) && !this.hasErrors;
    },
    issueStateOptions(): String[] {
      return this.$store.getters.issueStateOptions || [];
    },
    issuerOptions(): AutocompleteOption[] {
      return parseToAutocompleteOptionArray(this.$store.getters.issuerOptions) || [];
    },
  },
  created() {
    this.$store.dispatch('PULL_ISSUER_OPTIONS');
    this.$store.dispatch('PULL_ISSUE_STATE_OPTIONS');
  },
  methods: {
    async continueHandler(): Promise<void> {
      this.isContinueDisabled = true;
      try {
        const identificationDocumentFinancialSponsor: IdentificationDocumentFinancialSponsor = this
          .form;

        await this.$store.dispatch('UPDATE_IDENTIFICATION_DOCUMENT_FINANCIAL_SPONSOR', {
          identificationDocumentFinancialSponsor,
        });

        pipeline.next();
      } finally {
        this.isContinueDisabled = false;
      }
    },
    inputHandler(event: IdentificationDocumentFinancialSponsorFormEvent, hasErrors: boolean) {
      this.hasErrors = hasErrors;
      this.form = event;
    },
  },
});
